/// <amd-module name="Build/Extensions/GitHubEnterprise/ServiceConnections" />
import { ServiceConnectionInfo } from "Build/Extensions/Connection-Services/ServiceConnectionRetrieverService";
import * as Resources from "Build/Extensions/GitHubEnterprise/Resources";

import { EndpointAuthorization, ServiceEndpoint, ServiceEndpointType } from "DistributedTask/Client/Contracts/TaskAgent";
import { getTaskAgentClient } from "DistributedTask/Client/RestClient/TaskAgent";

import { SecurityNamespaceConstants } from "DistributedTaskUI/SecurityComponent/Constants";
import { IVssComponentContext } from "VSS/Platform/Layout";
import { IVssSecurityService } from "VSS/Platform/Security";

import { format } from "VSS/Core/Util/String";

export namespace Constant {
    export const GitHubAcquisitionFlow = "GitHubAcquisitionFlow";
    export const TokenScheme = "Token";
    export const UsernamePasswordScheme = "UsernamePassword";
}

export interface UserAuthorization {
    personalAccessToken: string; // pat
}

export function createEndpointName(serviceConnections: ServiceConnectionInfo[], originalName: string): string {
    let count = 1;
    let endpointName = originalName;
    const namesSet = new Set(serviceConnections.map(item => item.name));

    while (namesSet.has(endpointName)) {
        endpointName = format(Resources.ConnectionNameFormat, originalName, count);
        count++;
    }

    return endpointName;
}

export function createEndpointForUserAuth(
    context: IVssComponentContext,
    sourceProvider: string,
    serverUrl: string,
    acceptUntrustedCerts: boolean,
    projectId: string,
    serviceConnections: ServiceConnectionInfo[],
    userAuthorization: UserAuthorization): Promise<ServiceEndpoint> {

    serviceConnections = serviceConnections || [];

    const authorizationInfo: EndpointAuthorization = {
        scheme: Constant.TokenScheme,
        parameters: {
            apiToken: userAuthorization.personalAccessToken
        }
    }

    const data: { [key: string] : string } = {
        "acceptUntrustedCerts": acceptUntrustedCerts.toString()
        // GeneratedBy: Constant.GitHubAcquisitionFlow,
    };

    const serviceConnection: ServiceEndpoint = {
        type: sourceProvider,
        url: serverUrl,
        name: createEndpointName(serviceConnections, serverUrl),
        authorization: authorizationInfo,
        data: data
    } as ServiceEndpoint;

    const taskAgentClient = getTaskAgentClient(context.pageContext);
    return taskAgentClient.createServiceEndpoint(serviceConnection, projectId);
}

export function getServiceEndpointType(context: IVssComponentContext): Promise<ServiceEndpointType | undefined> {
    const taskAgentClient = getTaskAgentClient(context.pageContext);
    return taskAgentClient.getServiceEndpointTypes("githubenterprise")
        .then((serviceEnpointTypes: ServiceEndpointType[]) => {
            return (serviceEnpointTypes && serviceEnpointTypes.length > 0) ? serviceEnpointTypes[0] : undefined;
    });
}

export function checkProjectLevelManagePermission(context: IVssComponentContext, projectId: string): boolean {
    const securityService =  context.pageContext.getService<IVssSecurityService>("IVssSecurityService");
    let token = SecurityNamespaceConstants.Endpoints.concat(SecurityNamespaceConstants.NamespaceSeparator, projectId);
    return securityService.hasPermission(SecurityNamespaceConstants.NamespaceId, token, SecurityNamespaceConstants.AdminPermission);
}